/*
 * File: StayAliveHandler.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Hits the api every x amount of minutes to get a new JWT token
 */

import { useEffect } from "react";
import LoginApi from "../Api";

const keepAliveTimerSeconds = 60000 * 0.5; // 4 minutes

const StayAliveHandler = () => {
  useEffect(() => {
    const stayAlive = setInterval(() => {
      LoginApi.keepAlive();
    }, keepAliveTimerSeconds);

    return () => {
      // When this handler component is unmounted, we no longer want to make keep alive requests
      clearInterval(stayAlive);
    };
    // The effect should only run when the component is first mounted.
  }, []);

  // This component does not render anything.
  return null;
};

export default StayAliveHandler;
